const INVESTMENT_RETURN_TAB = 'investment-return-tab';
const INVESTMENT_RETURN_TAB_LABEL = 'Investment Return';
const EFFECTIVE_TAX_RATES_TAB = 'effective-tax-rates-tab';
const EFFECTIVE_TAX_RATES_TAB_LABEL = 'Effective Tax Rates';
const ANNUAL_INFLATION_CHANGES_TAB = 'annual-inflation-changes-tab';
const ANNUAL_INFLATION_CHANGES_TAB_LABEL = 'Annual Inflation Changes';

export const INFLATION_TAB = 'inflation-tab';
const INFLATION_TAB_LABEL = 'Inflation';
const AGE_BASED_TAB = 'age-based-tab';
const AGE_BASED_TAB_LABEL = 'Age-Based';
const LIMITS_TAB = 'limits-tab';
const LIMITS_TAB_LABEL = 'Limits';
const TAXES_TAB = 'taxes-tab';
const TAXES_TAB_LABEL = 'Taxes';
const STATE_TAXES_TAB = 'state-taxes-tab';
const STATE_TAXES_TAB_LABEL = 'State Taxes';
const INVESTMENTS_TAB = 'investments-tab';
const INVESTMENTS_TAB_LABEL = 'Investments';
const RETURNS_AND_WITHDRAWALS_TAB = 'returns-and-withdrawals-tab';
const RETURNS_AND_WITHDRAWALS_TAB_LABEL = 'Returns & Withdrawals';
const PENALTIES_TAB = 'penalties-tab';
const PENALTIES_TAB_LABEL = 'Penalties';
const COSTS_TAB = 'costs-tab';
const COSTS_TAB_LABEL = 'Costs';
const REAL_ASSETS_TAB = 'real-assets-tab';
const REAL_ASSETS_TAB_LABEL = 'Real Assets';
const STATE_529_PLAN_TAB = 'state-529-plan-tab';
const STATE_529_PLAN_TAB_LABEL = 'State Sponsored 529 Plans';
export const ASSUMPTIONS_TABS = [
  {
    key: INVESTMENT_RETURN_TAB,
    value: INVESTMENT_RETURN_TAB,
    label: INVESTMENT_RETURN_TAB_LABEL,
    test: INVESTMENT_RETURN_TAB,
    fields: [
      'cashPercentage',
      'customPercentage',
      'equityRiskPremium',
      'currentBondYield',
    ],
    name: [
      'CashPercentage',
      'CustomPercentage',
      'EquityRiskPremium',
      'CurrentBondYield',
    ],
  },
  {
    key: EFFECTIVE_TAX_RATES_TAB,
    value: EFFECTIVE_TAX_RATES_TAB,
    label: EFFECTIVE_TAX_RATES_TAB_LABEL,
    test: EFFECTIVE_TAX_RATES_TAB,
    fields: [
      'effectiveLongTermCapitalGainsFederalRatePercentage',
      'effectiveLongTermCapitalGainsStateRatePercentage',
      'effectiveIncomeFederalTaxRatePercentage',
      'effectiveIncomeStateTaxRatePercentage',
      'ficaTaxRatePercentage',
    ],
    name: [
      'EffectiveLongTermCapitalGainsFederalRatePercentage',
      'EffectiveLongTermCapitalGainsStateRatePercentage',
      'EffectiveIncomeFederalTaxRatePercentage',
      'EffectiveIncomeStateTaxRatePercentage',
      'FICATaxRatePercentage',
    ],
  },
  {
    key: ANNUAL_INFLATION_CHANGES_TAB,
    value: ANNUAL_INFLATION_CHANGES_TAB,
    label: ANNUAL_INFLATION_CHANGES_TAB_LABEL,
    test: ANNUAL_INFLATION_CHANGES_TAB,
    fields: [
      'incomeAdjustmentPercentage',
      'socialSecurityAdjustmentPercentage',
      'expenseAdjustmentPercentage',
      'otherFutureAdjustmentsPercentage',
      'hsaContributionLimitCatchUpInDollars',
      'hsaContributionLimitIndividualInDollars',
      'hsaContributionLimitFamilyInDollars',
      'retirementPlanIncomeLimitAnnualIncreasePercentage',
      'four01kAnnualContributionLimitIncreasePercentage',
      'collegeCostIncreasePercentage',
    ],
    name: [
      'IncomeAdjustmentPercentage',
      'SocialSecurityAdjustmentPercentage',
      'ExpenseAdjustmentPercentage',
      'OtherFutureAdjustmentsPercentage',
      'HsaContributionLimitCatchUpInDollars',
      'HsaContributionLimitIndividualInDollars',
      'HsaContributionLimitFamilyInDollars',
      'RetirementPlanIncomeLimitAnnualIncreasePercentage',
      'Four01kAnnualContributionLimitIncreasePercentage',
      'CollegeCostIncreasePercentage',
    ],
  },
  {
    key: INFLATION_TAB,
    value: INFLATION_TAB,
    label: INFLATION_TAB_LABEL,
    test: INFLATION_TAB,
    fields: ['expenseAdjustment',
      'socialSecurityAdjustment',
      'otherFutureAdjustments',
      'four01kAnnualContributionLimitIncrease',
      'four01kAnnualCatchupLimitMultiplier',
      'four01kAnnualExtraCatchUpLimitMultiplier',
      'simpleIraAnnualCatchupLimitMultiplier',
      'simpleIraAnnualExtraCatchUpLimitMultiplier',
      'iraAnnualContributionLimitIncrease',
      'incomeAdjustment',
      'individualAndFamily',
      'catchUp',
      'retirementPlanIncomeLimitAnnualIncrease',
      'educationCostInflation',
      'hsaContributionLimitInflation',
      'globalGeneralInflation',
      'healthCostAdjustmentPercentage',
      'refinanceDebtFeePercentage',
      'refinanceDebtRatePercentage',
    ],
    name: ['ExpenseAdjustmentPercentage',
      'SocialSecurityAdjustmentPercentage',
      'OtherFutureAdjustmentsPercentage',
      'Four01kAnnualContributionLimitIncreasePercentage',
      'Four01kAnnualCatchupLimitMultiplierPercentage',
      'Four01kAnnualExtraCatchUpLimitMultiplier',
      'SimpleIraAnnualCatchupMultiplierPercentage',
      'SimpleIraAnnualExtraCatchUpLimitMultiplier',
      'IraAnnualContributionLimitIncreasePercentage',
      'IncomeAdjustmentPercentage',
      'IndividualAndFamilyPercentage',
      'CatchUpPercentage',
      'RetirementPlanIncomeLimitAnnualIncreasePercentage',
      'EducationCostInflation',
      'HSAContributionLimitInflation',
      'GlobalGeneralInflation',
      'HealthCostAdjustmentPercentage',
      'RefinanceDebtFeePercentage',
      'RefinanceDebtRatePercentage',
    ],
  },
  {
    key: AGE_BASED_TAB,
    value: AGE_BASED_TAB,
    label: AGE_BASED_TAB_LABEL,
    test: AGE_BASED_TAB,
    fields: ['retirementContributionCatchUpAge',
      'qualifiedAccountWithdrawalAge',
      'hsaCatchUpAge',
      'four01kAnnualExtraCatchUpEndOfYearAgeMin',
      'four01kAnnualExtraCatchUpEndOfYearAgeMax',
      'simpleIraAnnualExtraCatchUpEndOfYearAgeMin',
      'simpleIraAnnualExtraCatchUpEndOfYearAgeMax',
      'socialSecurityStartAgeDefault',
      'socialSecurityStartAgeMin',
      'socialSecurityStartAgeMax',
      'retirementStartAge',
      'endOfFacetPlanAge'],
    name: [
      'RetirementContributionCatchUpAge',
      'QualifiedAccountWithdrawalAge',
      'HSACatchUpAge',
      'Four01kAnnualExtraCatchUpEndOfYearAgeMin',
      'Four01kAnnualExtraCatchUpEndOfYearAgeMax',
      'SimpleIraAnnualExtraCatchUpEndOfYearAgeMin',
      'SimpleIraAnnualExtraCatchUpEndOfYearAgeMax',
      'SocialSecurityStartAgeDefault',
      'SocialSecurityStartAgeMin',
      'SocialSecurityStartAgeMax',
      'RetirementStartAge',
      'EndOfFacetPlanAge',
    ],
  },
  {
    key: REAL_ASSETS_TAB,
    value: REAL_ASSETS_TAB,
    label: REAL_ASSETS_TAB_LABEL,
    test: REAL_ASSETS_TAB,
    fields: ['realEstateValueInflationPercentage',
      'realEstateCostToSellPercentage',
      'realEstateCostToBuyPercentage',
      'realEstateYearsToHoldForTaxFreeGainsOverExclusion',
      'realEstateGainsToExcludeForSingleInDollars',
      'realEstateGainsToExcludeForMarriedInDollars'],
    name: [
      'RealEstateValueInflationPercentage',
      'RealEstateCostToSellPercentage',
      'RealEstateCostToBuyPercentage',
      'RealEstateYearsToHoldForTaxFreeGainsOverExclusion',
      'RealEstateGainsToExcludeForSingleInDollars',
      'RealEstateGainsToExcludeForMarriedInDollars',
    ],
  },
  {
    key: LIMITS_TAB,
    value: LIMITS_TAB,
    label: LIMITS_TAB_LABEL,
    test: LIMITS_TAB,
    fields: [
      'four01kPreTaxCatchUpIncomeLimitCurrentYearInDollars',
      'four01kMaxContributionLimitCurrentYear',
      'four01kAnnualCatchUpLimitInDollars',
      'four01kExtraCatchUpMinimumLimitCurrentYearInDollars',
      'individual401kMaxContributionCurrentYearInDollars',
      'iraMaxContributionLimitCurrentYear',
      'mbrMaxContributionLimitCurrentYear',
      'sepIraContributionLimitCurrentYearInDollars',
      'simpleItaContributionLimitCurrentYear',
      'simpleIraAnnualCatchUpLimitInDollars',
      'simpleIraExtraCatchUpMinimumLimitCurrentYearInDollars',
      'iraCatchUpLimit',
      'hsaContributionLimitIndividual',
      'hsaContributionLimitFamily',
      'hsaContributionLimitCatchUp',
      'tradIraIncomeLimitCoveredByEmployerPlanYes',
      'tradIraIncomeLimitCoveredByEmployerPlanSpouse',
      'tradIraIncomeLimitSingle',
      'rothIraIncomeLimitMarriedFilingJointly',
      'rothIraIncomeLimitSingle',
      'hsaContributionLimitInflation',
      'emergencyFundMonthsMin',
      'nonelectiveEmployerMatchContributionLimit',
      'simpleIraAnnualMaxMatchingIncomeInDollars',
      'highInterestDebtThreshold',
      'socialSecurityTaxableIncomeMinimumSingle',
      'socialSecurityTaxableIncomeMaximumSingle',
      'socialSecurityTaxableIncomeMinimumMarried',
      'socialSecurityTaxableIncomeMaximumMarried',
      'medicarePremiumIncomeThresholdSingle',
      'medicarePremiumIncomeThresholdMarried',
      'niitIncomeThresholdSingle',
      'niitIncomeThresholdMarried',
    ],
    name: [
      'Four01kPreTaxCatchUpIncomeLimitCurrentYearInDollars',
      'Four01kMaxContributionLimitCurrentYearInDollars',
      'Four01kAnnualCatchUpLimitInDollars',
      'Four01kExtraCatchUpMinimumLimitCurrentYearInDollars',
      'Individual401kMaxContributionCurrentYearInDollars',
      'IraMaxContributionLimitCurrentYearInDollars',
      'MBR401kMaxContributionLimitCurrentYearInDollars',
      'SepIraContributionLimitCurrentYearInDollars',
      'SimpleIraContributionLimitCurrentYearInDollars',
      'SimpleIraAnnualCatchUpLimitInDollars',
      'SimpleIraExtraCatchUpMinimumLimitCurrentYearInDollars',
      'IraCatchUpLimitInDollars',
      'HsaContributionLimitIndividualInDollars',
      'HsaContributionLimitFamilyInDollars',
      'HsaContributionLimitCatchUpInDollars',
      'TradIraIncomeLimitCoveredByEmployerPlanYesInDollars',
      'TradIraIncomeLimitCoveredByEmployerPlanSpouseInDollars',
      'TradIraIncomeLimitSingleInDollars',
      'RothIraIncomeLimitMarriedFilingJointlyInDollars',
      'RothIraIncomeLimitSingleInDollars',
      'HSAContributionLimitInflation',
      'EmergencyFundMonthsMin',
      'NonelectiveEmployerMatchContributionLimitInDollars',
      'SimpleIraAnnualMaxMatchingIncomeInDollars',
      'HighInterestDebtThresholdPercentage',
      'SocialSecurityTaxableIncomeMinimumSingle',
      'SocialSecurityTaxableIncomeMaximumSingle',
      'SocialSecurityTaxableIncomeMinimumMarried',
      'SocialSecurityTaxableIncomeMaximumMarried',
      'MedicarePremiumIncomeThresholdSingle',
      'MedicarePremiumIncomeThresholdMarried',
      'NIITIncomeThresholdSingle',
      'NIITIncomeThresholdMarried',
    ],
  }, {
    key: TAXES_TAB,
    value: TAXES_TAB,
    label: TAXES_TAB_LABEL,
    test: TAXES_TAB,
    fields: [
      'effectiveLongTermCapitalGainsFederalRate',
      'effectiveLongTermCapitalGainsStateRate',
      'effectiveIncomeFederalTaxRate',
      'effectiveIncomeStateTaxRate',
      'fsaSavingAmountInDollars',
      'lifetimeLearningCreditAmountInDollars',
      'studentLoanInterestDeductionAmountInDollars',
      'childTaxCreditAmountInDollars',
      'qualifiedAdoptionExpensesCreditAmountInDollars',
      'americanOpportunityCreditAmountInDollars',
      'educationDeductionAmountInDollars',
      'ficaTaxRatePercentage',
      'socialSecurityUnderIncomeMaximumTaxRate',
      'socialSecurityOverIncomeMaximumTaxRate',
      'niitTaxRate',
      'standardDeductionSingleInDollars',
      'standardDeductionMarriedFilingJointlyInDollars',
    ],
    name: [
      'EffectiveLongTermCapitalGainsFederalRatePercentage',
      'EffectiveLongTermCapitalGainsStateRatePercentage',
      'EffectiveIncomeFederalTaxRatePercentage',
      'EffectiveIncomeStateTaxRatePercentage',
      'FSASavingAmountInDollars',
      'LifetimeLearningCreditAmountInDollars',
      'StudentLoanInterestDeductionAmountInDollars',
      'ChildTaxCreditAmountInDollars',
      'QualifiedAdoptionExpensesCreditAmountInDollars',
      'AmericanOpportunityCreditAmountInDollars',
      'EducationDeductionAmountInDollars',
      'FICATaxRatePercentage',
      'SocialSecurityUnderIncomeMaximumTaxRate',
      'SocialSecurityOverIncomeMaximumTaxRate',
      'NIITTaxRate',
      'StandardDeductionSingleInDollars',
      'StandardDeductionMarriedFilingJointlyInDollars',
    ],
  }, {
    key: STATE_TAXES_TAB,
    value: STATE_TAXES_TAB,
    label: STATE_TAXES_TAB_LABEL,
    test: STATE_TAXES_TAB,
    fields: [
      'effectiveIncomeStateTaxRateAl',
      'effectiveIncomeStateTaxRateAk',
      'effectiveIncomeStateTaxRateAz',
      'effectiveIncomeStateTaxRateAr',
      'effectiveIncomeStateTaxRateCa',
      'effectiveIncomeStateTaxRateCo',
      'effectiveIncomeStateTaxRateCt',
      'effectiveIncomeStateTaxRateDe',
      'effectiveIncomeStateTaxRateDc',
      'effectiveIncomeStateTaxRateFl',
      'effectiveIncomeStateTaxRateGa',
      'effectiveIncomeStateTaxRateHi',
      'effectiveIncomeStateTaxRateId',
      'effectiveIncomeStateTaxRateIl',
      'effectiveIncomeStateTaxRateIn',
      'effectiveIncomeStateTaxRateIa',
      'effectiveIncomeStateTaxRateKs',
      'effectiveIncomeStateTaxRateKy',
      'effectiveIncomeStateTaxRateLa',
      'effectiveIncomeStateTaxRateMe',
      'effectiveIncomeStateTaxRateMd',
      'effectiveIncomeStateTaxRateMa',
      'effectiveIncomeStateTaxRateMi',
      'effectiveIncomeStateTaxRateMn',
      'effectiveIncomeStateTaxRateMs',
      'effectiveIncomeStateTaxRateMo',
      'effectiveIncomeStateTaxRateMt',
      'effectiveIncomeStateTaxRateNe',
      'effectiveIncomeStateTaxRateNv',
      'effectiveIncomeStateTaxRateNh',
      'effectiveIncomeStateTaxRateNj',
      'effectiveIncomeStateTaxRateNm',
      'effectiveIncomeStateTaxRateNy',
      'effectiveIncomeStateTaxRateNc',
      'effectiveIncomeStateTaxRateNd',
      'effectiveIncomeStateTaxRateOh',
      'effectiveIncomeStateTaxRateOk',
      'effectiveIncomeStateTaxRateOr',
      'effectiveIncomeStateTaxRatePa',
      'effectiveIncomeStateTaxRateRi',
      'effectiveIncomeStateTaxRateSc',
      'effectiveIncomeStateTaxRateSd',
      'effectiveIncomeStateTaxRateTn',
      'effectiveIncomeStateTaxRateTx',
      'effectiveIncomeStateTaxRateUt',
      'effectiveIncomeStateTaxRateVt',
      'effectiveIncomeStateTaxRateVa',
      'effectiveIncomeStateTaxRateWa',
      'effectiveIncomeStateTaxRateWv',
      'effectiveIncomeStateTaxRateWi',
      'effectiveIncomeStateTaxRateWy',
    ],
    name: [
      'EffectiveIncomeStateTaxRatePercentageAL',
      'EffectiveIncomeStateTaxRatePercentageAK',
      'EffectiveIncomeStateTaxRatePercentageAZ',
      'EffectiveIncomeStateTaxRatePercentageAR',
      'EffectiveIncomeStateTaxRatePercentageCA',
      'EffectiveIncomeStateTaxRatePercentageCO',
      'EffectiveIncomeStateTaxRatePercentageCT',
      'EffectiveIncomeStateTaxRatePercentageDE',
      'EffectiveIncomeStateTaxRatePercentageDC',
      'EffectiveIncomeStateTaxRatePercentageFL',
      'EffectiveIncomeStateTaxRatePercentageGA',
      'EffectiveIncomeStateTaxRatePercentageHI',
      'EffectiveIncomeStateTaxRatePercentageID',
      'EffectiveIncomeStateTaxRatePercentageIL',
      'EffectiveIncomeStateTaxRatePercentageIN',
      'EffectiveIncomeStateTaxRatePercentageIA',
      'EffectiveIncomeStateTaxRatePercentageKS',
      'EffectiveIncomeStateTaxRatePercentageKY',
      'EffectiveIncomeStateTaxRatePercentageLA',
      'EffectiveIncomeStateTaxRatePercentageME',
      'EffectiveIncomeStateTaxRatePercentageMD',
      'EffectiveIncomeStateTaxRatePercentageMA',
      'EffectiveIncomeStateTaxRatePercentageMI',
      'EffectiveIncomeStateTaxRatePercentageMN',
      'EffectiveIncomeStateTaxRatePercentageMS',
      'EffectiveIncomeStateTaxRatePercentageMO',
      'EffectiveIncomeStateTaxRatePercentageMT',
      'EffectiveIncomeStateTaxRatePercentageNE',
      'EffectiveIncomeStateTaxRatePercentageNV',
      'EffectiveIncomeStateTaxRatePercentageNH',
      'EffectiveIncomeStateTaxRatePercentageNJ',
      'EffectiveIncomeStateTaxRatePercentageNM',
      'EffectiveIncomeStateTaxRatePercentageNY',
      'EffectiveIncomeStateTaxRatePercentageNC',
      'EffectiveIncomeStateTaxRatePercentageND',
      'EffectiveIncomeStateTaxRatePercentageOH',
      'EffectiveIncomeStateTaxRatePercentageOK',
      'EffectiveIncomeStateTaxRatePercentageOR',
      'EffectiveIncomeStateTaxRatePercentagePA',
      'EffectiveIncomeStateTaxRatePercentageRI',
      'EffectiveIncomeStateTaxRatePercentageSC',
      'EffectiveIncomeStateTaxRatePercentageSD',
      'EffectiveIncomeStateTaxRatePercentageTN',
      'EffectiveIncomeStateTaxRatePercentageTX',
      'EffectiveIncomeStateTaxRatePercentageUT',
      'EffectiveIncomeStateTaxRatePercentageVT',
      'EffectiveIncomeStateTaxRatePercentageVA',
      'EffectiveIncomeStateTaxRatePercentageWA',
      'EffectiveIncomeStateTaxRatePercentageWV',
      'EffectiveIncomeStateTaxRatePercentageWI',
      'EffectiveIncomeStateTaxRatePercentageWY',
    ],
  }, {
    key: INVESTMENTS_TAB,
    value: INVESTMENTS_TAB,
    label: INVESTMENTS_TAB_LABEL,
    test: INVESTMENTS_TAB,
    fields: ['portfolioTurnover',
      'retirementAccountContribution',
      'cashCheckingRateOfReturn',
      'cashSavingsRateOfReturn',
    ],
    name: [
      'PortfolioTurnoverPercentage',
      'RetirementAccountContribution',
      'CashCheckingRateOfReturnPercentage',
      'CashSavingsRateOfReturnPercentage',
    ],
  }, {
    key: RETURNS_AND_WITHDRAWALS_TAB,
    value: RETURNS_AND_WITHDRAWALS_TAB,
    label: RETURNS_AND_WITHDRAWALS_TAB_LABEL,
    test: RETURNS_AND_WITHDRAWALS_TAB,
    fields: ['conservative0100',
      'conservative1090',
      'conservative2080',
      'moderatelyConservative3070',
      'moderatelyConservative4060',
      'moderate5050',
      'moderate6040',
      'moderatelyAggressive7030',
      'moderatelyAggressive8020',
      'aggressive9010',
      'aggressive1000',
      'cash',
      'stsInterestRatePercentage',
      'highYieldAccountInterestPercentage',
    ],
    name: [
      'Conservative0100Percentage',
      'Conservative1090Percentage',
      'Conservative2080Percentage',
      'ModeratelyConservative3070Percentage',
      'ModeratelyConservative4060Percentage',
      'Moderate5050Percentage',
      'Moderate6040Percentage',
      'ModeratelyAggressive7030Percentage',
      'ModeratelyAggressive8020Percentage',
      'Aggressive9010Percentage',
      'Aggressive1000Percentage',
      'CashPercentage',
      'STSInterestRatePercentage',
      'FacetHighYieldAccountInterestPercentage',
    ],
  }, {
    key: PENALTIES_TAB,
    value: PENALTIES_TAB,
    label: PENALTIES_TAB_LABEL,
    test: PENALTIES_TAB,
    fields: ['retirementEarlyWithdrawalPenalty',
      'hsaUnqualifiedPenaltyPercentage',
      'five29UnqualifiedPenaltyPercentage'],
    name: [
      'EarlyWithdrawalPenaltyPercent',
      'HSAUnqualifiedPenaltyPercent',
      'Five29UnqualifiedPenaltyPercent',
    ],
  }, {
    key: COSTS_TAB,
    value: COSTS_TAB,
    label: COSTS_TAB_LABEL,
    test: COSTS_TAB,
    fields: ['medicareCostsInDollars',
      'longTermCareCostsInDollars',
      'sacSpendRemainderPercentage'],
    name: [
      'MedicareCostsInDollars',
      'LongTermCareCostsInDollars',
      'SACSpendRemainderPercentage',
    ],
  }, {
    key: STATE_529_PLAN_TAB,
    value: STATE_529_PLAN_TAB,
    label: STATE_529_PLAN_TAB_LABEL,
    test: STATE_529_PLAN_TAB,
    isState529Plan: true,
    name: [],
  },
];
